import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=778b5c8f&scoped=true&"
import script from "./gateway.vue?vue&type=script&lang=js&"
export * from "./gateway.vue?vue&type=script&lang=js&"
import style0 from "./gateway.vue?vue&type=style&index=0&id=778b5c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b5c8f",
  null
  
)

export default component.exports